import pdfMake from 'pdfmake/build/pdfmake'
import pdfFont from 'pdfmake/build/vfs_fonts'
import dateFunction from '@/modules/models/dateFunction'

pdfMake.vfs = pdfFont.pdfMake.vfs

async function StatReport (titlePDF, listDataAll, listData, selDistrict, param, currentDate, flagID) {
  pdfMake.fonts = {
    CordiaUPC: {
      normal: 'cordiau.ttf',
      bold: 'cordiaub.ttf',
      italics: 'cordiau.ttf',
      bolditalics: 'cordiauz.ttf'
    }
  }

  const dataAll = []
  const data = []
  const tableData = []
  const borderDataTable = [true, false, true, true]
  const layoutTable = {
    hLineWidth (i, node) {
      return 0.3
    },
    vLineWidth (i, node) {
      return 0.3
    }
  }

  listDataAll.forEach(v => {
    const dataRow = []
    if (parseInt(flagID) === 2 || parseInt(flagID) === 6) {
      dataRow.push({
        text: selDistrict === '' ? 'ยอดรวมทั้งจังหวัด' : 'ยอดรวมทั้งอำเภอ',
        border: borderDataTable,
        style: 'textnormal',
        alignment: 'right'
      })
    } else {
      dataRow.push({
        text: 'ยอดรวมทั้งประเทศ',
        style: 'textnormal',
        border: borderDataTable,
        alignment: 'right'
      })
    }
    dataRow.push({
      text: dateFunction.formatNumber(v.resultSum1),
      border: borderDataTable,
      style: 'textnormal',
      alignment: 'right'
    })
    dataRow.push({
      text: dateFunction.formatNumber(v.resultSum2),
      border: borderDataTable,
      style: 'textnormal',
      alignment: 'right'
    })
    dataRow.push({
      text: v.ratioSum.toLocaleString(),
      border: borderDataTable,
      style: 'textnormal',
      alignment: 'right'
    })
    dataAll.push(dataRow)
  })

  listData.forEach((v, i) => {
    let dataRow = []
    dataRow.push({
      text: i + 1,
      border: borderDataTable,
      style: 'textnormal',
      alignment: 'center'
    })
    dataRow.push({
      text: (param === '1') ? v.code.toString().substring(0, 2)
        : (!selDistrict) ? v.code.toString().substring(0, 4) : v.code.toString().substring(0, 6),
      border: borderDataTable,
      style: 'textnormal',
      alignment: 'center'
    })
    dataRow.push({
      text: v.desc,
      border: borderDataTable,
      style: 'textnormal',
      alignment: 'left'
    })
    dataRow.push({
      text: parseInt(param) < 4 || parseInt(param) === 6 ? dateFunction.formatNumber(v.male) : dateFunction.formatNumber(v.result1),
      border: borderDataTable,
      style: 'textnormal',
      alignment: 'right'
    })
    dataRow.push({
      text: parseInt(param) < 4 || parseInt(param) === 6 ? dateFunction.formatNumber(v.female) : dateFunction.formatNumber(v.result2),
      border: borderDataTable,
      style: 'textnormal',
      alignment: 'right'
    })
    dataRow.push({
      text: parseInt(param) < 4 || parseInt(param) === 6 ? dateFunction.formatNumber(v.total) : v.ratio.toLocaleString(),
      border: borderDataTable,
      style: 'textnormal',
      alignment: 'right'
    })
    data.push(dataRow)
  })

  var lenData = data.length
  var cutNumData = 30
  let divisionLen = (parseInt(lenData) / parseInt(cutNumData))
  let modLen = (parseInt(lenData) % parseInt(cutNumData))
  if (modLen !== 0) { divisionLen = parseInt(divisionLen) + 1 }
  let sliceStart = 0
  let sliceEnd = cutNumData
  for (let i = 0; i < divisionLen; i++) {
    const footPage = {
      text: `ณ วันที่ ${currentDate}`,
      absolutePosition: {
        x: 480,
        y: 805
      },
      pageBreak: i === divisionLen - 1 ? '' : 'after'
    }
    const header = [{
      text: titlePDF,
      alignment: 'center',
      bold: true,
      fontSize: 18
    }, {
      text: `${i + 1}`,
      style: 'textnormal',
      alignment: 'right',
      absolutePosition: {
        x: 0,
        y: 10
      }
    }]
    const tableHeader = !i ? {
      table: {
        widths: [207, 85, 85, 88.2],
        body: [
          [
            {
              text: '',
              alignment: 'center'
            },
            {
              text: (param !== '4' && param !== '5') ? 'จำนวนชาย (คน)'
                : (param === '4') ? 'จำนวนคนตาย (คน)' : 'จำนวนการย้ายเข้า',
              alignment: 'center'
            },
            {
              text: (param !== '4' && param !== '5') ? 'จำนวนหญิง (คน)'
                : (param === '4') ? 'จำนวนคนเกิด (คน)' : 'จำนวนการย้ายออก',
              alignment: 'center'
            },
            {
              text: (param !== '4' && param !== '5') ? 'รวม'
                : (param === '4') ? 'อัตราคนตาย 1 คนต่อคนเกิด' : 'อัตราย้ายเข้า 1 รายการต่อย้ายออก',
              alignment: 'center'
            }
          ]
        ]
      },
      layout: layoutTable,
      margin: [30, 15, 0, 0]
    } : {}
    const tableDataHeader = !i ? {
      border: [false, false, false, false],
      table: {
        widths: [207, 85, 85, 88.2],
        body: dataAll
      },
      layout: layoutTable,
      margin: [30, 0, 0, 0]
    } : {}
    const tableHeader2 = {
      table: {
        widths: [40, 50, 100, 85, 85, 88.5],
        body: [
          [
            {
              text: 'ลำดับ',
              alignment: 'center'
            },
            {
              text: (param !== '2' && param !== '6') ? 'รหัสจังหวัด'
                : (!selDistrict) ? 'รหัสอำเภอ' : 'รหัสตำบล',
              alignment: 'center'
            },
            {
              text: (param !== '2' && param !== '6') ? 'จังหวัด'
                : (!selDistrict) ? 'อำเภอ' : 'ตำบล',
              alignment: 'center'
            },
            {
              text: (param !== '4' && param !== '5') ? 'จำนวนชาย (คน)'
                : (param === '4') ? 'จำนวนคนตาย (คน)' : 'จำนวนการย้ายเข้า',
              alignment: 'center'
            },
            {
              text: (param !== '4' && param !== '5') ? 'จำนวนหญิง (คน)'
                : (param === '4') ? 'จำนวนคนเกิด (คน)' : 'จำนวนการย้ายออก',
              alignment: 'center'
            },
            {
              text: (param !== '4' && param !== '5') ? 'รวม'
                : (param === '4') ? 'อัตราคนตาย 1 คนต่อคนเกิด' : 'อัตราย้ายเข้า 1 รายการต่อย้ายออก',
              alignment: 'center'
            }
          ]
        ]
      },
      layout: layoutTable,
      margin: [30, 15, 0, 0]
    }
    const tableDataMain = {
      border: [false, false, false, false],
      table: {
        widths: [40, 50, 100, 85, 85, 88.5],
        body: data.slice(sliceStart, sliceEnd)
      },
      layout: layoutTable,
      margin: [30, 0, 0, 0]
    }
    tableData.push(header, tableHeader, tableDataHeader, tableHeader2, tableDataMain, footPage)
    sliceStart = sliceStart + cutNumData
    sliceEnd = sliceEnd + cutNumData
  }

  const docDefinition = {
    pageSize: 'A4',
    pageOrientation: 'portrait',
    content: [tableData],
    style: {
      textnormal: {
        fontSize: 14
      }
    }
  }
  return docDefinition
}

async function StatReport2 (titlePDF, listDataAll, listData, selDistrict, param, currentDate, flagID) {
  pdfMake.fonts = {
    CordiaUPC: {
      normal: 'cordiau.ttf',
      bold: 'cordiaub.ttf',
      italics: 'cordiau.ttf',
      bolditalics: 'cordiauz.ttf'
    }
  }

  const dataAll = []
  const data = []
  const tableData = []
  const borderDataTable = [true, false, true, true]
  const layoutTable = {
    hLineWidth (i, node) {
      return 0.3
    },
    vLineWidth (i, node) {
      return 0.3
    }
  }

  listDataAll.forEach(v => {
    const dataRow = []
    dataRow.push({
      text: '',
      border: [true, false, false, true]
    }, {
      text: '',
      border: [false, false, false, true]
    })
    if (selDistrict) {
      dataRow.push({
        text: selDistrict.substring(2, 4) === '00' ? 'ยอดรวมทั้งจังหวัด' : 'ยอดรวมทั้งอำเภอ',
        border: [false, false, true, true],
        style: 'textnormal',
        alignment: 'right'
      })
    } else {
      dataRow.push({
        text: 'ยอดรวมทั้งประเทศ',
        style: 'textnormal',
        border: [false, false, true, true],
        alignment: 'right'
      })
    }
    dataRow.push({
      text: dateFunction.formatNumber(v.maleTHSum),
      border: borderDataTable,
      style: 'textnormal',
      alignment: 'right'
    })
    dataRow.push({
      text: dateFunction.formatNumber(v.femaleTHSum),
      border: borderDataTable,
      style: 'textnormal',
      alignment: 'right'
    })
    dataRow.push({
      text: dateFunction.formatNumber(v.totalTHSum),
      border: borderDataTable,
      style: 'textnormal',
      alignment: 'right'
    })
    dataRow.push({
      text: dateFunction.formatNumber(v.maleNTHSum),
      border: borderDataTable,
      style: 'textnormal',
      alignment: 'right'
    })
    dataRow.push({
      text: dateFunction.formatNumber(v.femaleNTHSum),
      border: borderDataTable,
      style: 'textnormal',
      alignment: 'right'
    })
    dataRow.push({
      text: dateFunction.formatNumber(v.totalNTHSum),
      border: borderDataTable,
      style: 'textnormal',
      alignment: 'right'
    })
    dataRow.push({
      text: dateFunction.formatNumber(v.totalAll),
      border: borderDataTable,
      style: 'textnormal',
      alignment: 'right'
    })
    dataAll.push(dataRow)
  })
  // let isBangkok = false
  listData.forEach((v, i) => {
    v.code = v.code.toString()
    // if (v.code.substring(0, 2) === '10' && flagID === '6' && selDistrict === '') isBangkok = true
    let dataRow = []
    dataRow.push({
      text: i + 1,
      border: borderDataTable,
      style: 'textnormal',
      alignment: 'center'
    })
    dataRow.push({
      text: selDistrict === '' ? v.code.substring(0, 2) : v.code.substring(4, 6) === '00' ? v.code.substring(2, 4) : v.code.substring(4, 6),
      border: borderDataTable,
      style: 'textnormal',
      alignment: 'center'
    })
    dataRow.push({
      text: v.desc,
      border: borderDataTable,
      style: 'textnormal',
      alignment: 'left'
    })
    dataRow.push({
      text: dateFunction.formatNumber(v.maleThai),
      border: borderDataTable,
      style: 'textnormal',
      alignment: 'right'
    })
    dataRow.push({
      text: dateFunction.formatNumber(v.femaleThai),
      border: borderDataTable,
      style: 'textnormal',
      alignment: 'right'
    })
    dataRow.push({
      text: dateFunction.formatNumber(v.totalThai),
      border: borderDataTable,
      style: 'textnormal',
      alignment: 'right'
    })
    dataRow.push({
      text: dateFunction.formatNumber(v.maleNThai),
      border: borderDataTable,
      style: 'textnormal',
      alignment: 'right'
    })
    dataRow.push({
      text: dateFunction.formatNumber(v.femaleNThai),
      border: borderDataTable,
      style: 'textnormal',
      alignment: 'right'
    })
    dataRow.push({
      text: dateFunction.formatNumber(v.totalNThai),
      border: borderDataTable,
      style: 'textnormal',
      alignment: 'right'
    })
    dataRow.push({
      text: dateFunction.formatNumber(v.totalAll),
      border: borderDataTable,
      style: 'textnormal',
      alignment: 'right'
    })
    data.push(dataRow)
  })

  var lenData = data.length
  var cutNumData = 30
  let divisionLen = (parseInt(lenData) / parseInt(cutNumData))
  let modLen = (parseInt(lenData) % parseInt(cutNumData))
  if (modLen !== 0) { divisionLen = parseInt(divisionLen) + 1 }
  let sliceStart = 0
  let sliceEnd = cutNumData
  for (let i = 0; i < divisionLen; i++) {
    const footPage = {
      text: `ณ วันที่ ${currentDate}`,
      absolutePosition: {
        x: 480,
        y: 805
      },
      pageBreak: i === divisionLen - 1 ? '' : 'after'
    }
    const header = [{
      text: titlePDF,
      alignment: 'center',
      bold: true,
      fontSize: 18
    }, {
      text: `${i + 1}`,
      style: 'textnormal',
      alignment: 'right',
      absolutePosition: {
        x: 0,
        y: 10
      }
    }]
    const widthAllTable = [20, 15, 80, 45, 45, 45, 45, 45, 45, 45]
    const tableHeader = !i ? {
      table: {
        widths: widthAllTable,
        body: [
          [
            {
              text: '',
              colSpan: 3,
              alignment: 'center'
            },
            {
              text: '',
              alignment: 'center'
            },
            {
              text: '',
              alignment: 'center'
            },
            {
              text: 'ชาย(ไทย)',
              alignment: 'center'
            },
            {
              text: 'หญิง(ไทย)',
              alignment: 'center'
            },
            {
              text: 'รวม',
              alignment: 'center'
            },
            {
              text: 'ชาย(ไม่ใช่ไทย)',
              alignment: 'center',
              fontSize: 10
            },
            {
              text: 'หญิง(ไม่ใช่ไทย)',
              alignment: 'center',
              fontSize: 10
            },
            {
              text: 'รวม',
              alignment: 'center'
            },
            {
              text: 'รวมทั้งหมด',
              alignment: 'center'
            }
          ]
        ]
      },
      layout: layoutTable,
      margin: [30, 15, 0, 0]
    } : {}
    const tableDataHeader = !i ? {
      border: [false, false, false, false],
      table: {
        widths: widthAllTable,
        body: dataAll
      },
      layout: layoutTable,
      margin: [30, 0, 0, 0]
    } : {}
    const tableHeader2 = {
      table: {
        widths: [20, 15, 80, 45, 45, 45, 45, 45, 45, 45],
        body: [
          [
            {
              text: 'ลำดับ',
              alignment: 'center'
            },
            {
              text: 'รหัส',
              alignment: 'center'
            },
            {
              text: selDistrict ? selDistrict.substring(2, 4) === '00' ? 'ชื่ออำเภอ' : 'ชื่อตำบล' : 'ชื่อจังหวัด',
              alignment: 'center'
            },
            {
              text: 'ชาย(ไทย)',
              alignment: 'center'
            },
            {
              text: 'หญิง(ไทย)',
              alignment: 'center'
            },
            {
              text: 'รวม',
              alignment: 'center'
            },
            {
              text: 'ชาย(ไม่ใช่ไทย)',
              alignment: 'center',
              fontSize: 10
            },
            {
              text: 'หญิง(ไม่ใช่ไทย)',
              alignment: 'center',
              fontSize: 10
            },
            {
              text: 'รวม',
              alignment: 'center'
            },
            {
              text: 'รวมทั้งหมด',
              alignment: 'center'
            }
          ]
        ]
      },
      layout: layoutTable,
      margin: [30, 15, 0, 0]
    }
    const tableData2 = {
      border: [false, false, false, false],
      table: {
        widths: widthAllTable,
        body: data.slice(sliceStart, sliceEnd)
      },
      layout: layoutTable,
      margin: [30, 0, 0, 0]
    }
    tableData.push(header, tableHeader, tableDataHeader, tableHeader2, tableData2, footPage)
    sliceStart = sliceStart + cutNumData
    sliceEnd = sliceEnd + cutNumData
  }

  const docDefinition = {
    pageSize: 'A4',
    pageOrientation: 'portrait',
    content: [tableData],
    style: {
      textnormal: {
        fontSize: 14
      }
    }
  }
  return docDefinition
}

export default {
  StatReport,
  StatReport2,
  data () {
    return {}
  }
}
